import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: 3,
    display: "flex",
    marginBottom: 20,
    marginTop: 20,
    boxShadow: "none",
    borderRadius: 16,
    "&:hover": {
      '& [id^="next-photo-button-"], & [id^="previous-photo-button-"]': {
        opacity: 0.75,
        transition: "opacity 0.4s ease 0s",
      },
    },
  },
  link: {
    borderRadius: theme.shape.borderRadiusLarge,
    maxWidth: "calc(100% - 310px)",
  },
  details: {
    flex: "1 0 auto",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "column",
    height: 200,
  },
  mainContent: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    paddingBottom: 10,
  },
  bottomContent: {
    display: "flex",
    marginBottom: 5,
  },
  imageContainer: {
    position: "relative",
    height: 200,
    margin: 10,
    width: 300,
    "& img": {
      borderRadius: 8,
    },
  },
  carDealership: {
    marginTop: 4,
    height: 22,
    lineHeight: "22px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "flex",
  },
  carTitle: {
    marginTop: 20,
    fontWeight: 500,
    marginBottom: 10,
    lineHeight: "24px",
  },
  carStatus: {
    lineHeight: "22px",
    marginTop: 8,
    display: "flex",
  },
  cardStatImageContainer: {
    position: "relative",
    marginRight: 10,
    display: "inline",
  },
  imageChip: {
    position: "absolute",
    top: 10,
    left: 10,
    zIndex: theme.zIndex.vehicleCardChip,
  },
  focusHighlight: {
    backgroundColor: "unset",
  },
}));
